import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Local copy so the package does not reach into a host app's `lib/utils`. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
